import { styled } from '@mui/material/styles';
import { Icon } from '../Icon/Icon';
export const Container = styled('span')<{ isActive: boolean }>(({ isActive = false }) => ({
    display: 'flex',
    alignItems: 'center',
    '& > .chevron-icon': {
        width: '15px',
        height: '10px',
        ...(isActive && {
            transform: 'rotate(180deg)'
        })
    }
}));

const HideToggleSpan = styled('span')(() => ({
    marginRight: '8px'
}));

export const CollapseButton = ({ isHidden, onClick, t }: { isHidden: boolean; onClick: () => void; t: any }) => {
    return (
        <Container
            isActive={isHidden}
            sx={{
                color: 'black',
                display: 'flex',
                padding: '5px 10px',
                gap: '5px',
                marginLeft: 'auto'
            }}
            onClick={onClick}
        >
            <HideToggleSpan>{isHidden ? t('SHOW') : t('HIDE')}</HideToggleSpan>
            <Icon id="chevron-down" className="chevron-icon" />
        </Container>
    );
};
